// src/services/taikenService.js
// 体験入店関連のFirestore操作

import {
  collection, doc, addDoc, updateDoc,
  query, where, orderBy, limit, onSnapshot, serverTimestamp
} from 'firebase/firestore';
import { db } from '../config/firebase';

// ── 体験入店申込み作成 ──
export async function createTaikenApplication(data) {
  const appRef = await addDoc(collection(db, 'taikenApplications'), {
    userId: data.userId,
    jobId: data.jobId,
    shopName: data.shopName || '',
    area: data.area || '',
    introId: data.introId || '',
    preferredDate: data.preferredDate || '',
    confirmedDate: '',
    confirmedTime: '',
    status: 'applied', // applied → adjusting → confirmed → completed / cancelled
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });
  return appRef.id;
}

// ── ステータス更新 ──
export async function updateTaikenStatus(applicationId, status, confirmedDate = '', confirmedTime = '') {
  const updates = {
    status,
    updatedAt: serverTimestamp(),
  };
  if (confirmedDate) updates.confirmedDate = confirmedDate;
  if (confirmedTime) updates.confirmedTime = confirmedTime;
  await updateDoc(doc(db, 'taikenApplications', applicationId), updates);
}

// ── 全体験入店一覧（管理画面用・リアルタイム） ──
export function subscribeTaikenApplications(callback) {
  const q = query(
    collection(db, 'taikenApplications'),
    orderBy('createdAt', 'desc'),
    limit(200)
  );
  return onSnapshot(q, (snapshot) => {
    const apps = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
    callback(apps);
  });
}

// ── ユーザー別の体験入店一覧 ──
export function subscribeUserTaikenApplications(userId, callback) {
  const q = query(
    collection(db, 'taikenApplications'),
    where('userId', '==', userId),
    orderBy('createdAt', 'desc')
  ,
    limit(50)
  );
  return onSnapshot(q, (snapshot) => {
    const apps = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
    callback(apps);
  });
}
